export function generateGroupedTotalLogs<T>({
  records,
  groupByKey,
  valueKey,
  unit = "",
  formatKey = (key: string) => key,
}: {
  records: T[] | undefined;
  groupByKey: keyof T;
  valueKey: keyof T;
  unit?: string;
  formatKey?: (key: string) => string;
}) {
  if (!Array.isArray(records)) return [];

  const totals: Record<string, number> = {};

  records.forEach((record) => {
    const rawKey = record[groupByKey];
    const rawValue = record[valueKey];

    const key = String(rawKey);
    const value = Number(rawValue);

    if (!isNaN(value)) {
      totals[key] = (totals[key] || 0) + value;
    }
  });

  return Object.entries(totals).map(([key, total]) => ({
    label: formatKey(key),
    value: `${total}${unit}`,
  }));
}

export function generateBooleanCountLogs<T>({
  records,
  booleanKeys,
  labels,
}: {
  records: T[] | undefined;
  booleanKeys: (keyof T)[];
  labels: string[];
}) {
  if (!Array.isArray(records)) return [];

  return booleanKeys.map((key, index) => {
    const count = records.filter((r) => r[key] === true).length;
    const label = labels[index] || String(key);

    return {
      label,
      value: `${count} time${count !== 1 ? "s" : ""}`,
    };
  });
}
